export default __webpack_public_path__ + "static/media/coaches.8d90835c.png";